import { Divider, DividerProps } from "@mui/material";
import { styled } from '@mui/styles';

interface StyleDividerProps extends DividerProps {
    readonly styled: StyledProps;
}
export const StyleDivider = styled((props: StyleDividerProps) => (
    <Divider
        {...props}
        sx={{
            backgroundColor: props.styled.themeMode === 'light' ? 'rgba(4, 30, 73, 0.2)\n' : '#5d636d',
            borderColor: props.styled.themeMode === 'light' ? 'rgba(4, 30, 73, 0.2)\n' : '#5d636d',
        }}
    />
))(() => ({}));
